// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__afX67","left":"InfoRow_left__16WG8"};